<script setup>

const props = defineProps({
  text: {
    type: String,
  },
  side: {
    type: String,
    default: 'top',
  },
});
</script>

<template>
  <UTooltip :text="text" :delay-duration="200" :content="{
    side: side,
    class: 'max-w-80 h-auto min-h-[24px] py-2'
  }" :ui="{
    text: 'whitespace-normal break-words',
    content: 'h-auto flex items-start',
  }">
    <span class="cursor-pointer">
      <slot />
    </span>
  </UTooltip>
</template>
